<template>
  <div class="goods-code-collection">
    <div class="search-container">
      <el-form :inline="true" class="search-form">
        <el-form-item label="商品编码">
          <el-input placeholder="请输入商品编码"></el-input>
        </el-form-item>
        <el-form-item label="是否过期">
          <el-select v-model="expiredFilter" placeholder="全部">
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary">搜索</el-button>
          <el-button>重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="status-filter-bar">
      <span class="status-filter-label">状态：</span>
      <div class="status-filter-group">
        <el-radio-group v-model="statusFilter" size="medium">
          <el-radio label="all">全部</el-radio>
          <el-badge :value="statusCounts[0]" :hidden="statusCounts[0] === 0" type="warning" class="status-badge">
            <el-radio label="0">待采集</el-radio>
          </el-badge>
          <el-badge :value="statusCounts[5]" :hidden="statusCounts[5] === 0" type="primary" class="status-badge">
            <el-radio label="5">采集中</el-radio>
          </el-badge>
          <el-badge :value="statusCounts[1]" :hidden="statusCounts[1] === 0" type="danger" class="status-badge">
            <el-radio label="1">采集失败</el-radio>
          </el-badge>
          <el-badge :value="statusCounts[2]" :hidden="statusCounts[2] === 0" type="danger" class="status-badge">
            <el-radio label="2">待同步</el-radio>
          </el-badge>
          <el-radio label="3">已同步</el-radio>
          <el-radio label="4">无差异</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="button-toolbar">
      <div class="toolbar-left">
        <el-button size="medium" @click="handleFullCollection">全量采集</el-button>
        <el-button size="medium" @click="handleReCollection">重新采集</el-button>
        <el-button size="medium" @click="handleBatchSync">批量同步</el-button>
      </div>
      <div class="toolbar-right">
        <el-button size="medium">单一授权</el-button>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button :disabled="!(scope.row.status !== 0 && scope.row.status !== 5)" type="text" size="small" @click="handleCollect(scope.row)">采集</el-button>
          <el-button type="text" size="small" :disabled="scope.row.status !== 2" @click="handleSync(scope.row)">同步</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="商品编码" width="130">
        <template slot-scope="scope">
          <span>{{ scope.row.code || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="90">
        <template slot-scope="scope">
          <el-tag :type="getTagType(scope.row.status)">
            {{ scope.row.statusText }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="expired" label="是否过期" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0 || scope.row.status === 5 || scope.row.status === 1">-</span>
          <span v-else :class="scope.row.expired ? 'status-expired' : 'status-not-expired'">
            {{ scope.row.expired ? '是' : '否' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="version" label="版本号" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0 || scope.row.status === 5 || scope.row.status === 1">-</span>
          <span v-else>{{ scope.row.version || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="基础品名">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0 || scope.row.status === 5 || scope.row.status === 1">-</span>
          <span v-else>{{ scope.row.name || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="商品备注">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0 || scope.row.status === 5 || scope.row.status === 1">-</span>
          <span v-else>{{ scope.row.remark || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="spec" label="要素申报规范" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0 || scope.row.status === 5 || scope.row.status === 1">-</span>
          <span v-else>{{ scope.row.spec || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="unit1" label="法一单位">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0 || scope.row.status === 5 || scope.row.status === 1">-</span>
          <span v-else>{{ scope.row.unit1 || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="unit2" label="法二单位">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0 || scope.row.status === 5 || scope.row.status === 1">-</span>
          <span v-else>{{ scope.row.unit2 || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="dangerous" label="是否危险品">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0 || scope.row.status === 5 || scope.row.status === 1">-</span>
          <span v-else>{{ scope.row.dangerous === null ? "-" : (scope.row.dangerous ? '是' : '否') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="regulatoryCode" label="监管条件代码">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0 || scope.row.status === 5 || scope.row.status === 1">-</span>
          <span v-else>{{ scope.row.regulatoryCode || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="检疫Class" label="检验检疫类别">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0 || scope.row.status === 5 || scope.row.status === 1">-</span>
          <span v-else>{{ scope.row.检疫Class || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="taxRate" label="退税率">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0 || scope.row.status === 5 || scope.row.status === 1">-</span>
          <span v-else>{{ scope.row.taxRate || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="collectTime" label="采集结束时间" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.collectTime || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="syncTime" label="同步时间" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0 || scope.row.status === 5 || scope.row.status === 1">-</span>
          <span v-else>{{ scope.row.syncTime || '-' }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    
    <!-- 同步弹窗 -->
    <el-dialog
      title="同步商品编码信息"
      :visible.sync="syncDialogVisible"
      width="40%">
      <div class="sync-dialog-content">
        <h4>商品编码：{{ currentSyncRow ? currentSyncRow.code : '' }}</h4>
        <div class="version-info">
          <span>系统版本：20260401</span>
          <span>采集版本：20260420</span>
        </div>
        <el-table :data="syncDiffData" style="width: 100%">
          <el-table-column prop="field" label="字段" width="120"></el-table-column>
          <el-table-column prop="oldValue" label="原值"></el-table-column>
          <el-table-column prop="newValue" label="新值"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSync">取消</el-button>
        <el-button type="primary" @click="confirmSync">同步</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'GoodsCodeCollection',
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 200,
      completedCount: 156,
      selectedRows: [],
      statusFilter: "all",
      expiredFilter: '',
      statusCounts: {
        all: 0,
        0: 0,
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0
      },
      syncDialogVisible: false,
      currentSyncRow: null,
      syncDiffData: [
        { field: '基础品名', oldValue: '手机', newValue: '智能手机' },
        { field: '商品备注', oldValue: '智能移动电话', newValue: '智能移动电话（5G）' },
        { field: '退税率', oldValue: '13%', newValue: '11%' }
      ],
      statusMap: {
        0: '待采集',
        1: '采集失败',
        2: '待同步',
        3: '已同步',
        4: '无差异',
        5: '采集中'
      }
    }
  },
  mounted() {
    this.generateTableData()
  },
  methods: {
    generateTableData() {
      this.tableData = [
        {
          code: '8517121000',
          name: null,
          remark: null,
          spec: null,
          unit1: null,
          unit2: null,
          dangerous: null,
          regulatoryCode: null,
          检疫Class: null,
          taxRate: null,
          status: 0,
          statusText: this.statusMap[0],
          version: '',
          collectTime: '',
          syncTime: ''
        },
        {
          code: '8471300000',
          name: null,
          remark: '',
          spec: '',
          unit1: null,
          unit2: null,
          dangerous: null,
          regulatoryCode: null,
          检疫Class: null,
          taxRate: null,
          status: 1,
          statusText: this.statusMap[1],
          version: '',
          collectTime: '2026-04-21 09:37:41',
          syncTime: ''
        },
        {
          code: '8703231400',
          name: '轿车',
          remark: '排气量1.6升以下',
          spec: '品牌类型*|出口享惠情况*|材质(竹制)*|种类*|是否为一次性制品*|GTIN|CAS|其他',
          unit1: '044 - 辆',
          unit2: '012 - 台',
          dangerous: false,
          regulatoryCode: 'C',
          检疫Class: 'P',
          taxRate: '10%',
          status: 2,
          statusText: this.statusMap[2],
          version: '20260401',
          collectTime: '2026-04-20 10:00:00',
          syncTime: ''
        },
        {
          code: '9013803000',
          name: '相机',
          remark: '数码相机',
          spec: '品牌类型*|出口享惠情况*|材质(竹制)*|种类*|是否为一次性制品*|GTIN|CAS|其他',
          unit1: '012 - 台',
          unit2: '020 - 个',
          dangerous: false,
          regulatoryCode: 'D',
          检疫Class: 'Q',
          taxRate: '13%',
          status: 3,
          statusText: this.statusMap[3],
          version: '20260401',
          collectTime: '2026-04-20 11:00:00',
          syncTime: '2026-04-21 14:00:00'
        },
        {
          code: '7118100000',
          name: '珠宝',
          remark: '黄金首饰',
          spec: '品牌类型*|出口享惠情况*|材质(黄金)*|种类*|是否为一次性制品*|GTIN|CAS|其他',
          unit1: '036 - 克',
          unit2: '021 - 件',
          dangerous: false,
          regulatoryCode: 'E',
          检疫Class: 'R',
          taxRate: '13%',
          status: 4,
          statusText: this.statusMap[4],
          version: '20260401',
          collectTime: '2026-04-20 12:00:00',
          syncTime: ''
        },
        {
          code: '6205200000',
          name: '服装',
          remark: '棉制上衣',
          spec: '品牌类型*|出口享惠情况*|材质(棉制)*|种类*|是否为一次性制品*|GTIN|CAS|其他',
          unit1: '021 - 件',
          unit2: '050 - 套',
          dangerous: false,
          regulatoryCode: 'F',
          检疫Class: 'S',
          taxRate: '13%',
          status: 5,
          statusText: this.statusMap[5],
          version: '20260401',
          collectTime: '',
          syncTime: ''
        },
        {
          code: '6403990000',
          name: '鞋子',
          remark: '运动鞋',
          spec: '品牌类型*|出口享惠情况*|材质(棉制)*|种类*|是否为一次性制品*|GTIN|CAS|其他',
          unit1: '051 - 双',
          unit2: '020 - 个',
          dangerous: false,
          regulatoryCode: 'G',
          检疫Class: 'T',
          taxRate: '13%',
          status: 0,
          statusText: this.statusMap[0],
          version: '',
          collectTime: '',
          syncTime: ''
        },
        {
          code: '9102110000',
          name: '手表',
          remark: '机械手表',
          spec: '品牌类型*|出口享惠情况*|材质(竹制)*|种类*|是否为一次性制品*|GTIN|CAS|其他',
          unit1: '021 - 件',
          unit2: '020 - 个',
          dangerous: false,
          regulatoryCode: 'H',
          检疫Class: 'U',
          taxRate: '13%',
          status: 1,
          statusText: this.statusMap[1],
          version: '',
          collectTime: '2026-04-21 09:37:06',
          syncTime: ''
        },
        {
          code: '9004100000',
          name: '眼镜',
          remark: '光学眼镜',
          spec: '品牌类型*|出口享惠情况*|材质(竹制)*|种类*|是否为一次性制品*|GTIN|CAS|其他',
          unit1: '021 - 件',
          unit2: '020 - 个',
          dangerous: false,
          regulatoryCode: 'I',
          检疫Class: 'V',
          taxRate: '13%',
          status: 5,
          statusText: this.statusMap[5],
          version: '20260401',
          collectTime: '',
          syncTime: ''
        },
        {
          code: '9403300000',
          name: null,
          remark: null,
          spec: null,
          unit1: null,
          unit2: null,
          dangerous: null,
          regulatoryCode: null,
          检疫Class: null,
          taxRate: null,
          expired: true,
          status: 2,
          statusText: this.statusMap[2],
          version: null,
          collectTime: '2026-04-20 13:00:00',
          syncTime: ''
        }
      ]
      this.calculateStatusCounts()
    },
    calculateStatusCounts() {
      this.statusCounts = {
        all: this.tableData.length,
        0: this.tableData.filter(item => item.status === 0).length,
        1: this.tableData.filter(item => item.status === 1).length,
        2: this.tableData.filter(item => item.status === 2).length,
        3: this.tableData.filter(item => item.status === 3).length,
        4: this.tableData.filter(item => item.status === 4).length,
        5: this.tableData.filter(item => item.status === 5).length
      }
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection
    },
    handleFullCollection() {
      this.$confirm('全量采集会将当前已采集的数据清空，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 执行全量采集逻辑
        this.$message({ type: 'success', message: '全量采集任务已开始' })
      }).catch(() => {
        // 取消操作
      })
    },
    handleBatchSync() {
      if (this.selectedRows.length === 0) {
        this.$message({ type: 'warning', message: '请先选择商品编码' })
        return
      }
      this.$confirm(`是否继续同步${this.selectedRows.length}条商品编码信息？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 执行批量同步逻辑
        this.$message({ type: 'success', message: '批量同步任务已开始' })
      }).catch(() => {
        // 取消操作
      })
    },
    handleReCollection() {
      if (this.selectedRows.length === 0) {
        this.$message({ type: 'warning', message: '请先选择商品编码' })
        return
      }
      this.$confirm(`是否重新采集${this.selectedRows.length}条商品编码信息？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 执行重新采集逻辑
        this.$message({ type: 'success', message: '重新采集任务已开始' })
      }).catch(() => {
        // 取消操作
      })
    },
    handleCollect(row) {
      this.$confirm('会将当前已采集的数据清空，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 执行采集逻辑
        this.$message({ type: 'success', message: `开始采集商品编码 ${row.code}` })
      }).catch(() => {
        // 取消操作
      })
    },
    handleSync(row) {
      if (row.expired) {
        this.$confirm('该商品编码已过期是否确认同步？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.currentSyncRow = row
          this.syncDialogVisible = true
        }).catch(() => {
          // 取消操作
        })
      } else {
        this.currentSyncRow = row
        this.syncDialogVisible = true
      }
    },
    confirmSync() {
      // 执行同步逻辑
      this.syncDialogVisible = false
      this.$message({ type: 'success', message: `同步商品编码 ${this.currentSyncRow.code} 成功` })
    },
    cancelSync() {
      this.syncDialogVisible = false
      this.currentSyncRow = null
    },
    getTagType(status) {
      switch (status) {
        case 0: return 'warning' // 待采集 - 标签三（黄色）
        case 1: return 'danger'  // 采集失败 - 标签五（红色）
        case 2: return 'info'    // 待同步 - 标签一（蓝色）
        case 3: return 'success' // 已同步 - 标签二（绿色）
        case 4: return 'success' // 无差异 - 标签二（绿色）
        case 5: return 'primary' // 采集中 - 标签四（紫色）
        default: return ''
      }
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.generateTableData()
    },
    handleCurrentChange(current) {
      this.currentPage = current
      this.generateTableData()
    }
  }
}
</script>

<style scoped>
.goods-code-collection {
  padding: 0;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: var(--text-primary);
  display: inline-block;
  padding-bottom: 8px;
  border-bottom: 3px solid var(--primary-color);
}

.search-container {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 20px;
  margin-bottom: 16px;
  border: 1px solid var(--border-color);
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-end;
}

.search-form >>> .el-form-item {
  margin-bottom: 0;
}

.search-form >>> .el-form-item__label {
  font-weight: 500;
  color: var(--text-secondary);
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid var(--border-color);
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
}

.button-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  background-color: #fff;
  border-radius: 8px;
  padding: 16px 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border-color);
}

.toolbar-left {
  display: flex;
  gap: 12px;
  align-items: center;
}

.toolbar-left .el-button {
  transition: all 0.2s ease;
}

.toolbar-left .el-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.toolbar-right {
  font-size: 14px;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
}

.toolbar-right strong {
  color: var(--primary-color);
  font-weight: 600;
  margin: 0 4px;
}

.status-filter-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  padding: 12px 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border-color);
}

.status-filter-label {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 14px;
  white-space: nowrap;
}

.status-filter-group {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.status-filter-group .el-radio-group {
  display: flex;
  gap: 0;
}

.status-filter-group .el-radio {
  padding: 6px 14px;
  margin: 0;
  border: 1px solid var(--border-color);
  border-radius: 0;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 13px;
  color: var(--text-secondary);
}

.status-filter-group .el-radio:first-child {
  border-radius: 6px 0 0 6px;
}

.status-filter-group .el-radio:last-child {
  border-radius: 0 6px 6px 0;
}

.status-filter-group .el-radio:hover {
  border-color: var(--primary-color);
  color: var(--primary-color);
  z-index: 1;
}

.status-filter-group .el-radio.is-checked {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  color: #fff;
  z-index: 1;
}

.status-filter-group .el-radio + .el-radio {
  margin-left: 0;
}

.table-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
}

.table-actions .el-button {
  padding: 4px 8px;
  font-size: 13px;
}

.status-expired {
  color: var(--warning-color);
  font-weight: 500;
}

.status-not-expired {
  color: var(--success-color);
  font-weight: 500;
}

.sync-dialog-content {
  margin-bottom: 20px;
}

.sync-dialog-content h4 {
  margin-bottom: 16px;
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary);
}

.version-info {
  margin-bottom: 16px;
  display: flex;
  gap: 24px;
  font-size: 14px;
  color: var(--text-secondary);
  padding: 12px 16px;
  background-color: #fafafa;
  border-radius: 6px;
}

.version-info span {
  display: flex;
  align-items: center;
}

.version-info span::before {
  content: '';
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 8px;
}

.version-info span:first-child::before {
  background-color: var(--info-color);
}

.version-info span:last-child::before {
  background-color: var(--success-color);
}

.goods-code-collection >>> .el-table {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--border-color);
}

.goods-code-collection >>> .el-table th {
  background-color: #fafafa !important;
  font-weight: 600;
  color: var(--text-primary);
  font-size: 13px;
}

.goods-code-collection >>> .el-table td {
  padding: 12px 0;
  font-size: 13px;
}

.goods-code-collection >>> .el-table__row:hover > td {
  background-color: var(--primary-bg) !important;
}

.goods-code-collection >>> .el-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.goods-code-collection >>> .el-dialog__header {
  background-color: #fff;
  border-bottom: 1px solid var(--border-color);
  padding: 18px 24px;
}

.goods-code-collection >>> .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
}

.goods-code-collection >>> .el-dialog__body {
  padding: 20px 24px;
}

.goods-code-collection >>> .el-dialog__footer {
  border-top: 1px solid var(--border-color);
  padding: 14px 24px;
}

.goods-code-collection >>> .el-table--border {
  border: 1px solid var(--border-color);
}

.goods-code-collection >>> .el-table--border th,
.goods-code-collection >>> .el-table--border td {
  border-right: 1px solid var(--border-color);
}
</style>

<style>
.status-filter-group .el-radio__input {
  display: none;
}

.status-filter-group .el-radio__label {
  padding: 0;
}

.status-filter-group .el-radio.is-checked .el-radio__label {
  color: #fff !important;
}

.status-filter-group .status-badge {
  display: inline-flex;
}

.status-filter-group .status-badge .el-badge__content {
  top: -2px;
  right: 20px;
  z-index: 10;
}

.status-filter-group .status-badge .el-radio {
  border-radius: 0;
}

.status-filter-group .status-badge:first-child .el-radio {
  border-radius: 6px 0 0 6px;
}

.status-filter-group .status-badge:last-child .el-radio {
  border-radius: 0 6px 6px 0;
}
</style>